import React from 'react';
import CheckedImg from '@/assets/icons/icon-check-circle-green.svg';
import UncheckedImg from '@/assets/icons/icon-uncheck-circle-red.svg';
import DisableImg from '@/assets/icons/icon-check-circle-disabled.svg';
import { Container, ContainerItems, ItemText } from './styled';
import { CheckListItemProps, CheckListProps } from './types';
import IDHelpers from '@/core/helpers/IDHelper';

const CheckedListItems = ({
  items = [],
  itemsAlign,
  iconSize,
  paddingBottom
}: CheckListProps) => {
  if (items?.length < 1) return null;
  return (
    <Container data-testid="checklist-container" paddingBottom={paddingBottom}>
      {items.map((item: CheckListItemProps, index: number) => {
        const { itemText, isChecked, isDisabled, separator, onClick } = item;
        const getImageView = () => {
          if (isDisabled) return DisableImg;
          return isChecked ? CheckedImg : UncheckedImg;
        };
        return (
          <div key={`check-item-${index}-${IDHelpers.generateID()}`}>
            <ContainerItems
              onClick={() => onClick?.()}
              data-testid="checklist-item"
              alingItem={itemsAlign}
              iconSize={iconSize}
              disabled={isDisabled}
            >
              <img src={getImageView()} alt="CheckedImg" />
              <ItemText>{itemText}</ItemText>
            </ContainerItems>
            {separator && (
              <div
                className="separator-line"
                data-testid="separator-line-test"
              />
            )}
          </div>
        );
      })}
    </Container>
  );
};

export default CheckedListItems;
